module.exports = __webpack_public_path__ + "img/pop_nomoneye.b1c621e1.png";